import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TrendingUp, Users, BarChart3, DollarSign } from 'lucide-react';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    {
      path: '/overview',
      label: 'Overview',
      icon: TrendingUp,
    },
    {
      path: '/family',
      label: 'Family',
      icon: Users,
    },
    {
      path: '/projections',
      label: 'Projections',
      icon: BarChart3,
    },
    {
      path: '/income-expenses',
      label: 'Cash Flow',
      icon: DollarSign,
    },
  ];

  const isActive = (path: string) => {
    return location.pathname === path || 
      (path === '/income-expenses' && (location.pathname === '/income' || location.pathname === '/expenses')) ||
      (path === '/family' && (location.pathname === '/family-members' || location.pathname === '/investments')) ||
      (path === '/projections' && location.pathname === '/financial-model');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-[100] md:hidden shadow-lg" style={{ paddingBottom: 'max(8px, env(safe-area-inset-bottom, 0px))' }}>
      <div className="flex items-center justify-around px-2 py-2 h-16 max-w-full overflow-hidden">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center px-3 py-2 rounded-lg transition-colors ${
                active
                  ? 'text-primary-600'
                  : 'text-gray-500'
              }`}
            >
              <Icon className={`w-6 h-6 ${active ? 'text-primary-600' : 'text-gray-400'}`} />
              <span className={`text-xs mt-1 font-medium ${active ? 'text-primary-600' : 'text-gray-500'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;

